const doc = [({"en":({"models":({"proposal_vote":({"blank_vote":"Blank vote", "no":"No", "yes":"Yes"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;